export default __webpack_public_path__ + "static/media/remodel3.0fd76132.png";